import React from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FieldErrors } from 'react-hook-form';

interface FormStatusProps {
  isSubmitting: boolean;
  isDirty: boolean;
  isSubmitSuccessful: boolean;
  submitCount?: number;
  errors: FieldErrors;
  errorMessage?: string;
  showSuccess?: boolean;
}
export const FormStatus: React.FC<FormStatusProps> = ({
  isSubmitting,
  isSubmitSuccessful,
  submitCount = 0,
  isDirty,
  errors,
  errorMessage,
  showSuccess,
}) => {
  const { t } = useTranslation();
  if (isSubmitting) {
    return <Alert severity="info">{String(t('global.forms.saving'))}</Alert>;
  }
  if (Object.keys(errors).length > 0) {
    return (
      <Alert severity="error">
        {String(errorMessage || t('global.forms.validationErrors.generic'))}
      </Alert>
    );
  }
  if ((isSubmitSuccessful || submitCount > 0) && showSuccess !== false) {
    return <Alert severity="success">{String(t('global.forms.saved'))}</Alert>;
  }
  if (isDirty) {
    return <Alert severity="info">{String(t('global.forms.unsaved'))}</Alert>;
  }

  return <Alert severity="info">{String(t('global.forms.unchanged'))}</Alert>;
};
